import { computed } from 'mobx'
import type { ISchemaBoundValidationContext } from 'validx'
import { LegendPartViewModelBase } from '@/features/legends/editor/LegendPartViewModelBase'
import {
  type ErrorDescriptor,
  receiveErrors,
} from '@/features/legends/editor/analyzer-errors'

/**
 * Base for the legend's option groups, like the deadline or title config.
 * Formula configs are builders in their own right: their formulas see every
 * symbol declared by the builders before them. Each config validates itself
 * with its own schema.
 */
export abstract class ConfigEditorViewModelBase<
  TJson,
> extends LegendPartViewModelBase {
  /**
   * The config's validation, bound to its schema.
   */
  abstract readonly validation: ISchemaBoundValidationContext<
    ConfigEditorViewModelBase<TJson>
  >

  /**
   * The symbols the config's formulas can reference.
   */
  @computed
  protected get _symbolTable() {
    return this.dependencies.symbols.getSymbolTableFor(this)
  }

  /**
   * Sets the config from the legend document, where the legend may not have
   * one.
   */
  abstract hydrate(config: TJson | undefined): void

  /**
   * The config as the legend document has it.
   */
  abstract toJSON(): TJson

  /**
   * Shows the analyzer's errors on the config.
   */
  receiveErrors(descriptor: ErrorDescriptor) {
    receiveErrors(this, descriptor.inner)
  }
}
